/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".addpic_submit[_ngcontent-%COMP%]{width:400px;margin:0 auto}.uploadLogo[_ngcontent-%COMP%]   .addpic_submit.full_coulmn_btn[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{width:100%}\n/*# sourceMappingURL=uploadcompanylogo.component.css.map*/"];
export { styles as styles };
